// extracted by mini-css-extract-plugin
export default {"app":"Ds4VQ","app__install":"qIEdI","app__install-qr":"folDO"};